import router from '../../router/index'
import {getUserInfo, login, loginByToken, uploadUserAvatar} from "../../api/AuthController";
import {Loading} from "element-ui";
import {secureStorage} from "../../utils/security";

const user = {
  state: {
    userInfo: null,
    permissions: [],
    token: null
  },
  // 能保证获取到最新的值 eg: ...mapGetters(['userInfo']) this.$store.getters.userInfo
  getters: {
    userInfo: state => state.userInfo,
    token: state => state.token,
    permissions: state => state.permissions
  },
  // 调用方法 this.$store.commit("mutationName", data);
  mutations: {
    setToken(state, token){
      state.token = token;
    },
    setUserInfo(state, userInfo){
      state.userInfo = userInfo;
    },
  },
  // 调用方法 this.$store.dispatch("actionName", data);
  actions: {
    loginByToken({commit, state, dispatch}, token) {
      console.log("[通过本地缓存的令牌登录]");
      commit("setToken", token);
      loginByToken(token).then(result => {
        state.userInfo = result.data;
        commit("setToken", result.data.token);
        secureStorage.setItem('token', result.data.token);

        dispatch("generateSystemMenus", result.data.permissions); // 生成菜单路由表
        router.push({redirect: true, path: '/index'});
      }).catch(() => {
        secureStorage.removeItem("token");
      })
    },
    // 用户登录
    login({commit, state, dispatch}, requestUser) {
      login(requestUser).then(result => {
        state.userInfo = result.data;
        commit("setToken", result.data.token);
        secureStorage.setItem('token', result.data.token);
        // 不再存储完整的登录表单（包含密码），只存储用户名
        secureStorage.setItem("lastUsername", requestUser.username);

        dispatch("generateSystemMenus", result.data.permissions); // 生成菜单路由表
        router.push({redirect: true, path: '/index'});
      })
    },
    // 退出登录
    logout: ({commit, state}) => {
      commit("setToken", null);
      state.userInfo = null;
      secureStorage.removeItem('token');
      location.reload();
    },
    // 上传用户头像
    uploadUserAvatar({commit, state, dispatch}, file) {
      return new Promise((resolve, reject) => {
        uploadUserAvatar(file).then(response => {
          // 更新本地存储的userInfo
          const updatedUserInfo = { ...state.userInfo, avatar: response.data };
          state.userInfo = updatedUserInfo;
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js